<template>
  <div
    class="signer-item column-gap-1"
    :class="{ 'signer-item--icon': removable }"
    @dragstart="dragstart"
  >
    <span class="signer-item__fullname d-flex align-center">
      <app-material-icon name="drag_indicator" color="icon-secondary" class="mr-1" />
      <span class="text-text-secondary">{{ signer.fullName }}</span>
    </span>

    <app-button
      v-if="removable"
      type="icon"
      @click="remove"
    >
      <app-material-icon name="delete" />
    </app-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SignerOrderItem',
  props: {
    signerId: {
      type: Number,
      required: true,
    },
    removable: {
      type: Boolean,
    },
    groupIndex: {
      required: true,
      validator: (value) => { return typeof value === 'number' || value === null },
    },
  },
  computed: {
    ...mapGetters('groups', ['allRoomMembers']),
    signer () {
      return this.allRoomMembers.find(member => member.id === this.signerId)
    },
  },
  methods: {
    dragstart (event) {
      event.dataTransfer.setData('fromGroup', this.groupIndex)
      this.$emit('dragstart', event)
    },
    remove () {
      this.$emit('remove', this.signerId)
    },
  },
}
</script>

<style scoped lang="scss">
.signer-item {
  max-width: 200px;
  display: flex;
  align-items: center;
  background: rgb(var(--v-theme-surface-primary));
  border: 1px solid rgb(var(--v-theme-border-secondary));
  height: 50px;
  padding: 0 16px;
  border-radius: 4px;
  cursor: move;

  &__fullname {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  &--icon {
    padding: 0 10px 0 16px;
    justify-content: space-between;
  }
}
</style>
